export const landingAnchorRoutes = {
    issuers: {
        route: '#issuers',
        name: 'Эмитентам',
    },
    investors: {
        route: '#investors',
        name: 'Инвесторам',
    },
    partners: {
        route: '#partners',
        name: 'Партнерам',
    },
    news: {
        route: '#news',
        name: 'Новости',
    },
    registration: {
        route: 'registration',
        name: 'Регистрация',
    },
    documents: {
        route: 'information',
        name: 'Раскрытие информации',
    },
    contacts: {
        route: '#contacts',
        name: 'Контакты',
    },
};
